import React from "react";

import { VictoryAxis, VictoryLine } from "victory";
import { VictoryChart } from "victory-chart";

import { chartPadding, xAxisStyle, yAxisStyle } from "../utils/graph";
import { useWeeklyRatingGraph } from "../utils/useWeeklyRatingGraph";

const WeeklyRatingGraph: React.FC = () => {
  const {
    ratingHeartsGraphData,
    ratingThumbGraphData,
    ratingThinkGraphData,
    ratingMehGraphData,
    ratingFlagGraphData,
  } = useWeeklyRatingGraph();

  // yAxis values
  const yAxisValues = Array.from({ length: 13 }, (_, index) => index);

  const lineGraphData = [
    {
      lineGraphStyle: { stroke: "#FF9524" },
      data: ratingHeartsGraphData,
    },
    {
      lineGraphStyle: { stroke: "#FBB631" },
      data: ratingThumbGraphData,
    },
    {
      lineGraphStyle: { stroke: "#BFDA86" },
      data: ratingThinkGraphData,
    },
    {
      lineGraphStyle: { stroke: "#6EE2EA" },
      data: ratingMehGraphData,
    },
    {
      lineGraphStyle: { stroke: "#F27373" },
      data: ratingFlagGraphData,
    },
  ];

  return (
    <VictoryChart height={420} padding={chartPadding}>
      <VictoryAxis
        dependentAxis
        tickValues={yAxisValues}
        label="No. of Ojies"
        style={yAxisStyle}
      />

      <VictoryAxis standalone label="Dates" style={xAxisStyle} />
      {lineGraphData.map((graph, index) => (
        <VictoryLine
          key={index}
          style={{ data: { ...graph.lineGraphStyle, strokeWidth: 1 } }}
          x="date"
          y="totalRating"
          data={graph.data}
        />
      ))}
    </VictoryChart>
  );
};

export default WeeklyRatingGraph;
